import React from 'react';
import { Box, useMediaQuery, useTheme } from '@material-ui/core';
import { ChevronRight, ChevronUp } from '@carbon/icons-react';
import { colorSet } from '@components/Provider';
import { Spotlight, useSpotlight } from '@components/Spotlight';
import FakeChat from '../FakeChat';
import { TutorialStepProps } from '../CapaViewTutorial';

const TutorialStep2 = ({ handleNextStep, mockComments }: TutorialStepProps) => {
  const matches = useMediaQuery(useTheme().breakpoints.down('md'));
  const { load, targetRef, width, height } = useSpotlight();
  const myName = mockComments?.[0].commentUsers?.[0].userName ?? '나';

  return (
    <>
      {load && targetRef.current && (
        <Spotlight
          cutOutTarget={matches ? { x: '50%', y: '30%' } : targetRef.current}
          radiusSize={matches ? 180 : 319}
          CTATitle={
            <Box display={'flex'} alignItems={'center'}>
              {matches ? (
                <>
                  <ChevronUp color={colorSet.primary500} size={26} />
                  주석달기 클릭
                </>
              ) : (
                <>
                  주석달기 클릭
                  <ChevronRight color={colorSet.primary500} size={26} />
                </>
              )}
            </Box>
          }
          CTADirection={matches ? 'bottom' : 'left'}
          CTADescription={
            matches
              ? '도면 위에 원하는 위치를 짚으면 주석을 작성할 수 있어요.'
              : '도면 위에 원하는 위치를 짚으면 주석을 작성할 수 있어요. 작성된 주석에 답글도 남길 수 있어요.'
          }
          handleNextStep={() => handleNextStep(matches ? '2-2' : '3')}
          addX={matches ? 0 : -185}
          addY={matches ? 160 : 0}
          clientHeight={height}
          clientWidth={width}
        />
      )}
      {!matches && <FakeChat myName={myName} ref={targetRef} />}
    </>
  );
};

export default TutorialStep2;
